var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"menu-button",class:{ 'is-open': _vm.mobileMenuIsOpen, 'is-back': _vm.isInSecondLevel },attrs:{"aria-label":_vm.buttonLabel},on:{"click":_vm.handleClick}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon-wrapper"},[_c('span',{staticClass:"line line-1"}),_c('span',{staticClass:"line line-2"}),_c('span',{staticClass:"line line-3"})])
}]

export { render, staticRenderFns }